import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Represents the table commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define a date formatting function based on the application's configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request, ensuring it's required
        const cur_user = this.getParam('user', true);
        // Preserve the context of 'this' for use within nested functions
        var vthis = this;

        // Extend the default Webix data filter to create a custom summary column filter
        webix.ui.datafilter.mySummColumn = webix.extend(
            {
                /**
                 * Refresh the summary column with the calculated total value.
                 * @param {Object} master - The master view containing the data.
                 * @param {HTMLElement} node - The DOM node representing the summary cell.
                 * @param {string} value - The value object containing column information.
                 */
                refresh: function(master, node, value) {
                    var result = 0; // Initialize the result accumulator
                    var resultFormat = 0; // Variable to hold the formatted result
                    var size = $$('table').getPager().config.size; // Get the current page size
                    var page = $$('table').getPage(); // Get the current page number
                    var first = size * page; // Calculate the index of the first item on the page
                    var last = first + size - 1; // Calculate the index of the last item on the page
                    var count = 0; // Initialize a counter for iterating through data

                    // Iterate through each data object in the master view
                    master.data.each(function(obj) {
                        // Check if the current count is within the bounds of the current page
                        if (count >= first && count <= last) {
                            result += parseFloat(obj[value.columnId]); // Accumulate the value for the specified column
                        }
                        count++; // Increment the counter
                    });

                    // Format the result using the price format defined in Webix internationalization
                    resultFormat = webix.i18n.priceFormat(result);
                    // Update the inner HTML of the node with the formatted result
                    node.firstChild.innerHTML = resultFormat;
                },
            },
            // Inherit properties and methods from the existing summary column filter
            webix.ui.datafilter.summColumn,
        );

        return {
            view: 'datatable', // Defines the view type as a datatable
            id: 'table', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            scroll: true, // Enables scrolling
            columns: [ // Defines the columns of the datatable
                {
                    id: 'TypeName', // Unique identifier for the column
                    header: 'TypeName', // Header text for the column
                    width: 200, // Width of the column
                    template: function(obj, common) { // Template function for rendering cell content
                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Renders tree table if grouped
                        return obj.TypeName; // Returns TypeName for non-grouped rows
                    },
                    footer: 'Total:', // Footer text for the column
                },
                {
                    id: 'ActionTittle', // Unique identifier for the action column
                    header: '', // No header text
                    width: 70, // Width of the column
                    height: 25, // Height of the column
                    tooltip: _('Acción'), // Tooltip text for the column
                    template: function(obj) { // Template function for rendering action buttons
                        if (obj.State == 'E' || obj.State == null) { // Checks if the state is 'E' or null
                            if (devConfig.getPermAction('comissionsReportBetShopDetailApprove', 'Approve')) { // Checks permission for approval
                                return '<span placeholder=\'Aprobar\' class=\'webix_icon wxi-close approve prm-comissionsReportBetShopDetailApprove\'></span></span><span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsReportBetShopDetailApprove\'></span>'; // Returns approve and pay buttons
                            } else {
                                return ''; // Returns empty if no permission
                            }
                        } else {
                            if (obj.State == 'A' || obj.State == null) { // Checks if the state is 'A' or null
                                if (devConfig.getPermAction('comissionsReportBetShopDetailPay', 'Pay')) { // Checks permission for payment
                                    return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close pay prm-comissionsReportBetShopDetailPay\'></span>'; // Returns pay button
                                } else {
                                    return ''; // Returns empty if no permission
                                }
                            } else {
                                return ''; // Returns empty for other states
                            }
                        }
                    },
                },
                { id: 'Id', header: 'ID', width: 70, sort: 'int' }, // Column for ID with sorting
                {
                    id: 'ClientId', // Unique identifier for the client ID column
                    header: _('ID Usuario'), // Header text for the column
                    width: 95, // Width of the column
                    sort: 'int', // Enables sorting
                },
                {
                    id: 'CreatedLocal', // Unique identifier for the creation date column
                    header: _('Fecha de creación'), // Header text for the column
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Width of the column
                    sort: 'text', // Enables sorting
                    format: dateFormat, // Date formatting function
                },
                {
                    id: 'CurrencyId', // Unique identifier for the currency column
                    header: _('Moneda'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                },
                {
                    id: 'Bets', // Unique identifier for the bets column
                    header: _('Apuestas'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                    format: webix.Number.numToStr({ // Number formatting for bets
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'mySummColumn' }, // Footer content for summation
                    editor: 'text', // Editor type for inline editing
                },
                {
                    id: 'Winnings', // Unique identifier for the winnings column
                    header: _('Premios'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                    format: webix.Number.numToStr({ // Number formatting for winnings
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'mySummColumn' }, // Footer content for summation
                    editor: 'text', // Editor type for inline editing
                },
                {
                    id: 'Bonus', // Unique identifier for the bonus column
                    header: _('Bonos'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                    format: webix.Number.numToStr({ // Number formatting for bonuses
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'mySummColumn' }, // Footer content for summation
                    editor: 'text', // Editor type for inline editing
                },
                {
                    id: 'AmountBase', // Unique identifier for the base amount column
                    header: _('Valor Base'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                    format: webix.Number.numToStr({ // Number formatting for base amount
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'mySummColumn' }, // Footer content for summation
                    editor: 'text', // Editor type for inline editing
                },
                {
                    id: 'Amount', // Unique identifier for the commission amount column
                    header: _('Comision'), // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Enables sorting
                    format: webix.Number.numToStr({ // Number formatting for commission
                        groupDelimiter: ',',
                        groupSize: 3,
                        decimalDelimiter: '.',
                        decimalSize: 2,
                    }),
                    footer: { content: 'mySummColumn' }, // Footer content for summation
                    editor: 'text', // Editor type for inline editing
                },
                {
                    id: 'ModifiedLocal', // Unique identifier for the modified date column
                    header: _('Modificado'), // Header text for the column
                    fillspace: 0, // No fill space
                    minWidth: 0, // Minimum width
                    width: 150, // Width of the column
                    sort: 'text', // Enables sorting
                    format: dateFormat, // Date formatting function
                },
                {
                    id: 'NTC', header: _('NTC'), // Unique identifier for the NTC column
                    fillspace: 0, minWidth: 0, width: 150, // Column dimensions
                    sort: 'text', // Enables sorting
                },
                {
                    id: 'ExternalId', // Unique identifier for the external ID column
                    header: _('External ID'), // Header text for the column
                    width: 150, // Width of the column
                    sort: 'int', // Enables sorting
                },
            ],
            onClick: { // Event handlers for click events
                pay: function(euv, id) { // Handler for pay button click
                    var vvthis = this; // Reference to the current context
                    webix
                        .modalbox({ // Displays a modal box for payment options
                            title: _('Pregunta '), // Title of the modal
                            buttons: [ // Buttons in the modal
                                _('Efectivo'),
                                _('Saldo Recarga'),
                                _('Saldo Juego'),
                                _('Saldo Afiliados'),
                                _('Cancelar'),
                            ],
                            text: _('Seleccione el tipo de saldo '), // Text in the modal
                            width: screen.width < 500 ? 300 : 500, // Width based on screen size
                            height: screen.width < 500 ? 200 : 0, // Height based on screen size
                        })
                        .then(function(result) { // Handles the result of the modal
                            switch (result) { // Switch based on selected option
                                case '0': // Cash payment option
                                    webix.confirm({ // Confirmation dialog for cash payment
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea pagar comisión en efectivo?'), // Warning text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to pay commission in cash
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsCash', // API endpoint
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                                webix.message(_('Error! ')); // Display error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                                item.State = 'P'; // Update item state to paid
                                                                webix.message(_('Comisión Pagada')); // Display success message
                                                                vthis.$$('table').clearAll(); // Clear the datatable
                                                                vthis.$$('table').load(url); // Reload the datatable
                                                                webix
                                                                    .ui({ // Create a new window for the invoice
                                                                        view: 'window',
                                                                        width: 500,
                                                                        height: 700,
                                                                        head: {
                                                                            view: 'toolbar',
                                                                            cols: [
                                                                                {
                                                                                    view: 'label',
                                                                                    label: _('Factura'), // Invoice label
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    label: 'X', // Close button
                                                                                    width: 100,
                                                                                    align: 'right',
                                                                                    click: '$(\'windowfact2\').close();', // Close action
                                                                                },
                                                                            ],
                                                                        },
                                                                        id: 'windowfact2', // Unique identifier for the window
                                                                        modal: true, // Modal window
                                                                        position: 'center', // Center position
                                                                        body: {
                                                                            rows: [
                                                                                {
                                                                                    template:
                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for displaying PDF
                                                                                },
                                                                            ],
                                                                        },
                                                                    })
                                                                    .show(); // Show the window
                                                                var reader = new FileReader(); // FileReader for reading PDF data
                                                                reader.onload = function(event) { // On load event
                                                                    $$('pdf').clear(); // Clear previous PDF
                                                                    $$('pdf').parse({ // Parse new PDF data
                                                                        data: event.target.result,
                                                                    });
                                                                };

                                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert base64 to Blob
                                                                    contentType = contentType || ''; // Default content type
                                                                    sliceSize = sliceSize || 512; // Default slice size
                                                                    var byteCharacters = atob(b64Data); // Decode base64
                                                                    var byteArrays = []; // Array to hold byte arrays
                                                                    for (
                                                                        var offset = 0;
                                                                        offset < byteCharacters.length;
                                                                        offset += sliceSize
                                                                    ) {
                                                                        var slice = byteCharacters.slice(
                                                                            offset,
                                                                            offset + sliceSize,
                                                                        ); // Slice the byte characters
                                                                        var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                        for (var i = 0; i < slice.length; i++) {
                                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                        }
                                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                                        byteArrays.push(byteArray); // Push to byte arrays
                                                                    }
                                                                    var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                                        type: contentType,
                                                                    });
                                                                    return blob; // Return the Blob
                                                                }

                                                                var contentType = 'application/pdf'; // Content type for PDF
                                                                var b64Data = data.Pdf; // Base64 data for PDF
                                                                var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                                var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                                console.log(blob); // Log the Blob
                                                                document.querySelector('iframe').src = file; // Set iframe source to the file
                                                                var printWindow = window.open( // Open a new window for printing
                                                                    file,
                                                                    '',
                                                                    'width=800,height=500',
                                                                );
                                                                printWindow.print(); // Trigger print
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '1': // Recharge balance payment option
                                    webix.confirm({ // Confirmation dialog for recharge payment
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo recargas?'), // Warning text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to pay commission from recharge
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsRecharge', // API endpoint
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                                webix.message(_('Error! ')); // Display error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                                item.State = 'P'; // Update item state to paid
                                                                webix.message(_('Comisión Pagada')); // Display success message
                                                                vthis.$$('table').clearAll(); // Clear the datatable
                                                                vthis.$$('table').load(url); // Reload the datatable
                                                                webix
                                                                    .ui({ // Create a new window for the invoice
                                                                        view: 'window',
                                                                        width: 500,
                                                                        height: 700,
                                                                        head: {
                                                                            view: 'toolbar',
                                                                            cols: [
                                                                                {
                                                                                    view: 'label',
                                                                                    label: _('Factura'), // Invoice label
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    label: 'X', // Close button
                                                                                    width: 100,
                                                                                    align: 'right',
                                                                                    click: '$(\'windowfact2\').close();', // Close action
                                                                                },
                                                                            ],
                                                                        },
                                                                        id: 'windowfact2', // Unique identifier for the window
                                                                        modal: true, // Modal window
                                                                        position: 'center', // Center position
                                                                        body: {
                                                                            rows: [
                                                                                {
                                                                                    template:
                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for displaying PDF
                                                                                },
                                                                            ],
                                                                        },
                                                                    })
                                                                    .show(); // Show the window
                                                                var reader = new FileReader(); // FileReader for reading PDF data
                                                                reader.onload = function(event) { // On load event
                                                                    $$('pdf').clear(); // Clear previous PDF
                                                                    $$('pdf').parse({ // Parse new PDF data
                                                                        data: event.target.result,
                                                                    });
                                                                };

                                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert base64 to Blob
                                                                    contentType = contentType || ''; // Default content type
                                                                    sliceSize = sliceSize || 512; // Default slice size
                                                                    var byteCharacters = atob(b64Data); // Decode base64
                                                                    var byteArrays = []; // Array to hold byte arrays
                                                                    for (
                                                                        var offset = 0;
                                                                        offset < byteCharacters.length;
                                                                        offset += sliceSize
                                                                    ) {
                                                                        var slice = byteCharacters.slice(
                                                                            offset,
                                                                            offset + sliceSize,
                                                                        ); // Slice the byte characters
                                                                        var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                        for (var i = 0; i < slice.length; i++) {
                                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                        }
                                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                                        byteArrays.push(byteArray); // Push to byte arrays
                                                                    }
                                                                    var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                                        type: contentType,
                                                                    });
                                                                    return blob; // Return the Blob
                                                                }

                                                                var contentType = 'application/pdf'; // Content type for PDF
                                                                var b64Data = data.Pdf; // Base64 data for PDF
                                                                var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                                var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                                console.log(blob); // Log the Blob
                                                                document.querySelector('iframe').src = file; // Set iframe source to the file
                                                                var printWindow = window.open( // Open a new window for printing
                                                                    file,
                                                                    '',
                                                                    'width=800,height=500',
                                                                );
                                                                printWindow.print(); // Trigger print
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '2': // Game balance payment option
                                    webix.confirm({ // Confirmation dialog for game balance payment
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo juego?'), // Warning text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to pay commission from game balance
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsGame', // API endpoint
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                                webix.message(_('Error! ')); // Display error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                                item.State = 'P'; // Update item state to paid
                                                                webix.message(_('Comisión Pagada')); // Display success message
                                                                vthis.$$('table').clearAll(); // Clear the datatable
                                                                vthis.$$('table').load(url); // Reload the datatable
                                                                webix
                                                                    .ui({ // Create a new window for the invoice
                                                                        view: 'window',
                                                                        width: 500,
                                                                        height: 700,
                                                                        head: {
                                                                            view: 'toolbar',
                                                                            cols: [
                                                                                {
                                                                                    view: 'label',
                                                                                    label: _('Factura'), // Invoice label
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    label: 'X', // Close button
                                                                                    width: 100,
                                                                                    align: 'right',
                                                                                    click: '$(\'windowfact2\').close();', // Close action
                                                                                },
                                                                            ],
                                                                        },
                                                                        id: 'windowfact2', // Unique identifier for the window
                                                                        modal: true, // Modal window
                                                                        position: 'center', // Center position
                                                                        body: {
                                                                            rows: [
                                                                                {
                                                                                    template:
                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for displaying PDF
                                                                                },
                                                                            ],
                                                                        },
                                                                    })
                                                                    .show(); // Show the window
                                                                var reader = new FileReader(); // FileReader for reading PDF data
                                                                reader.onload = function(event) { // On load event
                                                                    $$('pdf').clear(); // Clear previous PDF
                                                                    $$('pdf').parse({ // Parse new PDF data
                                                                        data: event.target.result,
                                                                    });
                                                                };

                                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert base64 to Blob
                                                                    contentType = contentType || ''; // Default content type
                                                                    sliceSize = sliceSize || 512; // Default slice size
                                                                    var byteCharacters = atob(b64Data); // Decode base64
                                                                    var byteArrays = []; // Array to hold byte arrays
                                                                    for (
                                                                        var offset = 0;
                                                                        offset < byteCharacters.length;
                                                                        offset += sliceSize
                                                                    ) {
                                                                        var slice = byteCharacters.slice(
                                                                            offset,
                                                                            offset + sliceSize,
                                                                        ); // Slice the byte characters
                                                                        var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                        for (var i = 0; i < slice.length; i++) {
                                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                        }
                                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                                        byteArrays.push(byteArray); // Push to byte arrays
                                                                    }
                                                                    var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                                        type: contentType,
                                                                    });
                                                                    return blob; // Return the Blob
                                                                }

                                                                var contentType = 'application/pdf'; // Content type for PDF
                                                                var b64Data = data.Pdf; // Base64 data for PDF
                                                                var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                                var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                                console.log(blob); // Log the Blob
                                                                document.querySelector('iframe').src = file; // Set iframe source to the file
                                                                var printWindow = window.open( // Open a new window for printing
                                                                    file,
                                                                    '',
                                                                    'width=800,height=500',
                                                                );
                                                                printWindow.print(); // Trigger print
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '3': // Affiliates balance payment option
                                    webix.confirm({ // Confirmation dialog for affiliates balance payment
                                        type: 'confirm-warning',
                                        text:
                                            _('Advertencia!') + '<br/>' + _('Desea abonar comisión a saldo afiliados?'), // Warning text
                                        ok: _('Pagar Comisión'), // Confirm button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function(action) { // Callback for confirmation action
                                            if (action === true) { // If confirmed
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to pay commission from affiliates balance
                                                    .headers({
                                                        'Content-type': 'application/json', // Set content type
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Commisions/PayCommisionsAffiliates', // API endpoint
                                                        '{ "Id":' + item.Id + '}', // Request body
                                                        {
                                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                                webix.message(_('Error! ')); // Display error message
                                                            },
                                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                                item.State = 'P'; // Update item state to paid
                                                                webix.message(_('Comisión Pagada')); // Display success message
                                                                vthis.$$('table').clearAll(); // Clear the datatable
                                                                vthis.$$('table').load(url); // Reload the datatable
                                                                webix
                                                                    .ui({ // Create a new window for the invoice
                                                                        view: 'window',
                                                                        width: 500,
                                                                        height: 700,
                                                                        head: {
                                                                            view: 'toolbar',
                                                                            cols: [
                                                                                {
                                                                                    view: 'label',
                                                                                    label: _('Factura'), // Invoice label
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    label: 'X', // Close button
                                                                                    width: 100,
                                                                                    align: 'right',
                                                                                    click: '$(\'windowfact2\').close();', // Close action
                                                                                },
                                                                            ],
                                                                        },
                                                                        id: 'windowfact2', // Unique identifier for the window
                                                                        modal: true, // Modal window
                                                                        position: 'center', // Center position
                                                                        body: {
                                                                            rows: [
                                                                                {
                                                                                    template:
                                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for displaying PDF
                                                                                },
                                                                            ],
                                                                        },
                                                                    })
                                                                    .show(); // Show the window
                                                                var reader = new FileReader(); // FileReader for reading PDF data
                                                                reader.onload = function(event) { // On load event
                                                                    $$('pdf').clear(); // Clear previous PDF
                                                                    $$('pdf').parse({ // Parse new PDF data
                                                                        data: event.target.result,
                                                                    });
                                                                };

                                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert base64 to Blob
                                                                    contentType = contentType || ''; // Default content type
                                                                    sliceSize = sliceSize || 512; // Default slice size
                                                                    var byteCharacters = atob(b64Data); // Decode base64
                                                                    var byteArrays = []; // Array to hold byte arrays
                                                                    for (
                                                                        var offset = 0;
                                                                        offset < byteCharacters.length;
                                                                        offset += sliceSize
                                                                    ) {
                                                                        var slice = byteCharacters.slice(
                                                                            offset,
                                                                            offset + sliceSize,
                                                                        ); // Slice the byte characters
                                                                        var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                                        for (var i = 0; i < slice.length; i++) {
                                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                                        }
                                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                                        byteArrays.push(byteArray); // Push to byte arrays
                                                                    }
                                                                    var blob = new Blob(byteArrays, { // Create Blob from byte arrays
                                                                        type: contentType,
                                                                    });
                                                                    return blob; // Return the Blob
                                                                }

                                                                var contentType = 'application/pdf'; // Content type for PDF
                                                                var b64Data = data.Pdf; // Base64 data for PDF
                                                                var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                                var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                                console.log(blob); // Log the Blob
                                                                document.querySelector('iframe').src = file; // Set iframe source to the file
                                                                var printWindow = window.open( // Open a new window for printing
                                                                    file,
                                                                    '',
                                                                    'width=800,height=500',
                                                                );
                                                                printWindow.print(); // Trigger print
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                    break;
                                case '4': // No action for option 4
                                    break;
                            }
                        });
                },
                approve: function(euv, id) { // Handler for approve button click
                    var vvthis = this; // Reference to the current context
                    webix.confirm({ // Confirmation dialog for approving commission
                        type: 'confirm-warning',
                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar Comisión'), // Warning text
                        ok: _('Aprobar Comisión'), // Confirm button text
                        cancel: _('Salir'), // Cancel button text
                        callback: function(action) { // Callback for confirmation action
                            if (action === true) { // If confirmed
                                var item = vvthis.getItem(id); // Get the item from the datatable
                                webix
                                    .ajax() // AJAX request to approve commission
                                    .headers({
                                        'Content-type': 'application/json', // Set content type
                                    })
                                    .post(
                                        devConfig.geturlApi() + 'Commisions/ApproveComission', // API endpoint
                                        '{ "Id":' + item.Id + '}', // Request body
                                        {
                                            error: function(text, data, XmlHttpRequest) { // Error handler
                                                webix.message(_('Error! ')); // Display error message
                                            },
                                            success: function(text, data, XmlHttpRequest) { // Success handler
                                                item.State = 'P'; // Update item state to approved
                                                webix.message(_('Comision Aprobado')); // Display success message
                                                vthis.$$('table').clearAll(); // Clear the datatable
                                                vthis.$$('table').load(url); // Reload the datatable
                                                webix
                                                    .ui({ // Create a new window for the invoice
                                                        view: 'window',
                                                        width: 500,
                                                        height: 700,
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Factura'), // Invoice label
                                                                },
                                                                {
                                                                    view: 'button',
                                                                    label: 'X', // Close button
                                                                    width: 100,
                                                                    align: 'right',
                                                                    click: '$(\'windowfact2\').close();', // Close action
                                                                },
                                                            ],
                                                        },
                                                        id: 'windowfact2', // Unique identifier for the window
                                                        modal: true, // Modal window
                                                        position: 'center', // Center position
                                                        body: {
                                                            rows: [
                                                                {
                                                                    template:
                                                                        '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for displaying PDF
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show(); // Show the window
                                                var reader = new FileReader(); // FileReader for reading PDF data
                                                reader.onload = function(event) { // On load event
                                                    $$('pdf').clear(); // Clear previous PDF
                                                    $$('pdf').parse({ // Parse new PDF data
                                                        data: event.target.result,
                                                    });
                                                };

                                                function b64toBlob(b64Data, contentType, sliceSize) { // Function to convert base64 to Blob
                                                    contentType = contentType || ''; // Default content type
                                                    sliceSize = sliceSize || 512; // Default slice size
                                                    var byteCharacters = atob(b64Data); // Decode base64
                                                    var byteArrays = []; // Array to hold byte arrays
                                                    for (
                                                        var offset = 0;
                                                        offset < byteCharacters.length;
                                                        offset += sliceSize
                                                    ) {
                                                        var slice = byteCharacters.slice(offset, offset + sliceSize); // Slice the byte characters
                                                        var byteNumbers = new Array(slice.length); // Array for byte numbers
                                                        for (var i = 0; i < slice.length; i++) {
                                                            byteNumbers[i] = slice.charCodeAt(i); // Convert to byte numbers
                                                        }
                                                        var byteArray = new Uint8Array(byteNumbers); // Create Uint8Array
                                                        byteArrays.push(byteArray); // Push to byte arrays
                                                    }
                                                    var blob = new Blob(byteArrays, { type: contentType }); // Create Blob from byte arrays
                                                    return blob; // Return the Blob
                                                }

                                                var contentType = 'application/pdf'; // Content type for PDF
                                                var b64Data = data.Pdf; // Base64 data for PDF
                                                var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                var file = window.URL.createObjectURL(blob); // Create object URL for Blob
                                                console.log(blob); // Log the Blob
                                                document.querySelector('iframe').src = file; // Set iframe source to the file
                                                var printWindow = window.open(file, '', 'width=800,height=500'); // Open a new window for printing
                                                printWindow.print(); // Trigger print
                                            },
                                        },
                                    );
                            }
                        },
                    });
                },
            },
            on: { // Event handlers for datatable events
                onBeforeLoad: function() { // Before loading data
                    this.showOverlay( // Show overlay while loading
                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                    );
                },
                onAfterLoad: function() { // After loading data
                    this.hideOverlay(); // Hide overlay
                },
            },
            ready: function() { // When the datatable is ready
                if (!this.count()) { // If there are no rows
                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                    this.showOverlay( // Show no data overlay
                        '<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>',
                    );
                }
            },
            footer: true, // Enable footer
            math: true, // Enable math functions
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager identifier
        };
    }

    /**
     * Initializes the view components and event handlers.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and assign it to the variable '_'
        const _ = this.app.getService('locale')._;
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        // Construct the API URL for fetching commissions
        const url = devConfig.geturlApi() + 'es/Financial/GetComissions?FromId=' + cur_user + '&';
        // Initialize an empty filter string
        var filter = '';
        // Listen for the 'depositReport:filter' event to apply filters to the grid
        this.on(this.app, 'depositReport:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize an empty string to build the query parameters
            var string1 = '';
            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        // Append dateFrom and dateTo parameters to the string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested object entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date and append to the string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date and append to the string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Append the current user ID to the filter string
            string1 = string1 + '&FromId=' + cur_user;
            // Clear the grid before loading new data
            grid.clearAll();
            // Load the grid with the constructed URL and filter parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
        });
        // Attach an event to handle sorting in the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Reload the grid with the sorted data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        // Attach an event to handle item clicks in the grid
        grid.attachEvent('onItemClick', function(id, e, node) {
            // Retrieve the clicked item from the grid
            var item = this.getItem(id);
            // Trigger an event with the selected item's ID
            this.$scope.app.callEvent('deposit:id', [item.Id]);
        });
        // Listen for the 'player:select' event to load data based on selected player
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid with data filtered by the selected player ID
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + user);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
